export const navigationItems = [
  { path: "/", key: "navigation.home" },
  { path: "/about", key: "navigation.about" },
  { path: "/services", key: "navigation.services" },
  { path: "/contact", key: "navigation.contact" },
];
